import { findProtocol } from "../api/protocol";
import ProtocolType from "../../../backend/models/ProtocolType.ts";

export default {
  methods: {
    async openProtocol(protocol, options = {}) {
      if (!protocol) return;
      const preventRedirect =
        typeof options === "boolean" ? options : options.preventRedirect;
      const companyId = options.companyId || null;

      try {
        const response = await findProtocol(protocol, { companyId });
        const data = response.data;

        if (data.results || preventRedirect) {
          return data;
        }

        const { _id, type } = data;
        if (type === ProtocolType.QAS) {
          this.$router.push({ path: `/duvidas-e-sugestoes/${_id}` });
        } else if (type === ProtocolType.DSAR) {
          this.$router.push({ path: `/lgpd/${_id}` });
        } else if (type === ProtocolType.OMBUDSMAN) {
          this.$router.push({ path: `/ouvidoria/${_id}` });
        } else {
          this.$router.push({ path: `/denuncias/${_id}` });
        }
      } catch (error) {
        if (
          error.response &&
          error.response.status >= 400 &&
          error.response.status < 500
        ) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        } else {
          this.$bvToast.toast(
            error.response?.statusText || "Erro ao buscar protocolo",
            {
              title: "Erro",
              toastClass: "custom-toast custom-toast-error",
              variant: "light",
              solid: true,
              autoHideDelay: 10000,
              noCloseButton: false,
            }
          );
        }
      }
    },
  },
};
